import React, { useEffect } from "react";
import HeaderNav from "./common/HeaderNav";
import Footer from "./Footer";
import refund from "../images/refund.png";

function RefundPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title =
      "Refund Policy | Trusted Provider of Premium Mobile Numbers Since 2010";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Learn about VIP Number Studio, a trusted provider of premium mobile numbers across India since 2010. Discover our commitment to delivering over 10,000 exclusive numbers and our dedication to customer satisfaction."
      );
  }, []);
  return (
    <>
      <HeaderNav />
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          overflow: "hidden",
          marginTop: "60px",
        }}
      >
        {/* Background Image */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage: `url(${refund})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            background: "#000040",
          }}
        ></div>
        {/* Red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            top: "-150px",
            right: "-100px",
            zIndex: 1,
          }}
        ></div>

        {/* Second red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "150px",
            height: "150px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            bottom: "-70px",
            left: "50px",
            zIndex: 1,
          }}
        ></div>

        {/* Decorative dots */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            left: "20px",
            display: "flex",
            gap: "5px",
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
        </div>

        {/* Decorative triangle */}
        <div
          style={{
            position: "absolute",
            bottom: "15px",
            right: "60px",
            width: 0,
            height: 0,
            borderLeft: "15px solid transparent",
            borderRight: "15px solid transparent",
            borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
            transform: "rotate(45deg)",
          }}
        ></div>

        {/* Content Container */}
        <div
          style={{
            position: "relative",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "0 20px",
            zIndex: "2",
          }}
        >
          <h1
            style={{
              color: "white",
              fontSize: "42px",
              fontWeight: "800",
              marginBottom: "16px",
              textAlign: "center",
              textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
            }}
          >
            Refund Policy
          </h1>

          <p
            style={{
              color: "white",
              fontSize: "18px",
              fontWeight: "400",
              maxWidth: "700px",
              textAlign: "center",
              textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
            }}
          >
            No cancellations & Refunds are entertained
          </p>

          {/* Decorative Line */}
          <div
            style={{
              width: "80px",
              height: "4px",
              background:
                "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
              marginTop: "20px",
              borderRadius: "2px",
            }}
          ></div>
        </div>
      </div>
      <div className="refund-policy">
        <div className="container">
          <div className="row">
            <h2 className="policy-header">Cancellation & Refund Policy</h2>
            <h5 className="text-muted my-4">
              Last updated on {new Date().getFullYear()}
            </h5>
            <p className="my-4">No cancellations & Refunds are entertained</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RefundPolicy;
